
export function validatePassword (rule, value, callback) {
    if (value && !value.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/)) {
        callback('Hasło powinno zawierać przynajmniej jedną małą, jedną wielką literę oraz jedną cyfrę.');
    } else {
        callback();
    }
}